module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "demoPage"
  }, [_c('div', {
    staticClass: "navTabs fixed-content"
  }, [_c('div', {
    staticClass: "tabs",
    on: {
      "click": function($event) {
        return _vm.toPage('/studentRoomManger')
      }
    }
  }, [_vm._v("整体情况")]), _vm._v(" "), _c('div', {
    staticClass: "tabs border-bottom-03a9f4 color-appStyle"
  }, [_vm._v("楼栋情况")]), _vm._v(" "), _c('div', {
    staticClass: "tabs",
    on: {
      "click": function($event) {
        return _vm.toPage('/studentRoomMangerTwo')
      }
    }
  }, [_vm._v("学院分布表")])]), _vm._v(" "), _c('div', {
    staticClass: "tabContent scroll-content"
  }, [_c('div', {
    staticClass: "grid",
    staticStyle: {
      "padding": "0",
      "margin-top": "10px"
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.dormAreaList.length > 0) ? _c('div', _vm._l((_vm.dormAreaList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "gridWarp bg-fff"
    }, [_c('div', {
      staticClass: "gridCell flex-1",
      class: {
        'bold': item.zoneName == '总计'
      }
    }, [_vm._v(_vm._s(item.zoneName))]), _vm._v(" "), _c('div', {
      staticClass: "gridCell flex-1"
    }, [_vm._v(_vm._s(item.allCnt))]), _vm._v(" "), _c('div', {
      staticClass: "gridCell flex-1"
    }, [_vm._v(_vm._s(item.yrzCnt))]), _vm._v(" "), _c('div', {
      staticClass: "gridCell flex-1"
    }, [_vm._v(_vm._s(item.kzfCnt))]), _vm._v(" "), _c('div', {
      staticClass: "gridCell flex-1"
    }, [_vm._v(_vm._s(item.psfCnt))]), _vm._v(" "), _c('div', {
      staticClass: "gridCell flex-1"
    }, [_vm._v(_vm._s(item.rzblStr))])])
  }), 0) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gridWarp bg-appStyle color-fff"
  }, [_c('div', {
    staticClass: "gridCell flex-1 bold"
  }, [_vm._v("楼栋")]), _vm._v(" "), _c('div', {
    staticClass: "gridCell flex-1 bold"
  }, [_vm._v("房间总数")]), _vm._v(" "), _c('div', {
    staticClass: "gridCell flex-1 bold"
  }, [_vm._v("已入住")]), _vm._v(" "), _c('div', {
    staticClass: "gridCell flex-1 bold"
  }, [_vm._v("空置房")]), _vm._v(" "), _c('div', {
    staticClass: "gridCell flex-1 bold"
  }, [_vm._v("破损房")]), _vm._v(" "), _c('div', {
    staticClass: "gridCell flex-1 bold"
  }, [_vm._v("入住率")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60eb9d57"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/FloorSituation.vue
// module id = 862
// module chunks = 1